import { Injectable } from "@angular/core";
import { APP_CONSTANTS } from "../../../core/constants/app.constants";
import type {
  IceServerConfig,
  TurnCredentialsResponse,
} from "../models/video.models";

const FALLBACK_ICE: IceServerConfig[] = [
  { urls: "stun:stun.l.google.com:19302" },
  { urls: "stun:stun1.l.google.com:19302" },
  { urls: "stun:stun2.l.google.com:19302" },
  { urls: "stun:stun3.l.google.com:19302" },
  { urls: "stun:stun4.l.google.com:19302" },
];

@Injectable()
export class VideoIceService {
  private cached: IceServerConfig[] | null = null;
  private expiresAt = 0;

  async getIceServers(userId: string): Promise<IceServerConfig[]> {
    if (this.cached && Date.now() < this.expiresAt) return this.cached;

    try {
      const url = `${APP_CONSTANTS.apiBaseUrl}/api/turn-credentials?userId=${encodeURIComponent(userId)}`;
      const res = await fetch(url);
      const data = (await res.json()) as TurnCredentialsResponse;
      this.cached = data.iceServers;
      // Expire 60s before the credential TTL to avoid edge cases
      this.expiresAt = Date.now() + data.ttl * 1000 - 60_000;
      return this.cached;
    } catch {
      return FALLBACK_ICE;
    }
  }
}
